export default __webpack_public_path__ + "static/media/mission.3032514b.jpg";